const unsupportedProps = (restProps) => {
  const restPropsKeys = Object.keys(restProps)

  if (restPropsKeys.length > 0) {
    throw new Error(`Unsupported props: ${restPropsKeys.join(", ")}`)
  }
}

export default unsupportedProps
